import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import Aura from '@primeuix/themes/aura';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import '@/assets/styles/style.css';
import admin_main_router from './router';
import App from './App.vue';

// Restaurer la couleur d'accent sauvegardée
const savedAccent = localStorage.getItem('nxt-admin-accent');
if (savedAccent) {
  document.documentElement.style.setProperty('--nxt-primary', savedAccent);
  document.documentElement.style.setProperty(
    '--nxt-primary-container',
    savedAccent,
  );
}
import i18n from './i18n';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
pinia.use(piniaPluginPersistedstate as any);
// Cache partagé entre toutes les vues : évite de refetch les données déjà
// chargées récemment quand on navigue (ex. retour sur le dashboard).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});
app.use(VueQueryPlugin, {
  queryClient,
  enableDevtoolsV6Plugin: true,
});
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      // PrimeVue lira la classe dark sur l'élément <html> via data-theme="dark"
      darkModeSelector: '[data-theme="dark"]',
    },
  },
});
app.use(i18n);
app.use(admin_main_router);

// Mount only after the router has resolved the initial route. Otherwise App.vue
// renders one frame against the router's START_LOCATION (path '/'), which makes
// the layout condition briefly choose the authenticated shell — the sidebar
// flashes in then disappears once the real route (e.g. /login) resolves.
admin_main_router.isReady().then(() => {
  app.mount('#app');
});
